import React from 'react';
import classnames from 'classnames';

export default function BooleanRadioButton({
  field,
  form: {setFieldValue},
  label,
  value,
  onChange,
  ...props
}) {
  return (
    <label
      className={classnames({
        'kt-radio': true,
        'kt-radio--brand': true,
      })}
    >
      <input
        {...props}
        type="radio"
        name={field.name}
        value={value}
        checked={field.value === value}
        onClick={() => {
          setFieldValue(field.name, value);
          if (onChange) {
            onChange();
          }
        }}
      />
      <div style={props.disabled ? {opacity: '0.2'} : {}}>{label}</div>
      <span />
    </label>
  );
}
